const STORAGE_KEY = 'u3204.lastMissionId';

/**
 * Lit la dernière mission sélectionnée (null = toutes les missions).
 */
export function readLastMissionId(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null || raw === '') {
      return null;
    }
    return raw;
  } catch {
    return null;
  }
}

/**
 * Persiste la mission sélectionnée (null = toutes les missions).
 */
export function writeLastMissionId(missionId: string | null): void {
  try {
    if (missionId === null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, missionId);
    }
  } catch {
    // ignore quota / private mode
  }
}
